import { useEffect, useRef, forwardRef } from 'react'
import { DragOutlined } from '@ant-design/icons'

import { renderTranslation } from '../../../Helpers/GenericHelpers'
import { TranslationKeys } from '../../../Constants/TranslationKeys'
import { UiCodePIM, descriptionsContainer, descriptionsSectionId } from '../../../Constants/Configuration'
import Descriptions from './Descriptions'
import { useAppSelector } from '../../../hooks'
import RenderByProfileOptionWrapper from 'Components/Generic/RenderByProfileOptionWrapper'

function DescriptionGridLayout({ style, className, onMouseDown, onMouseUp, onTouchEnd, children, ...props }, ref) {
  const language = useAppSelector(state => state.present.language.value)
  const articleSelected = useAppSelector(state => state.present.articleDetail.articleSelected)
  const isImagesVisible = useAppSelector(state => state.present.configuration.isImagesVisible)
  const workspaceImagesVisible = useAppSelector(state => state.present.configuration.workspaceImagesVisible)
  const isDescriptionsFetched = articleSelected.fetchedDescriptions

  const descBoxDomElementRef = useRef(null)

  useEffect(() => {
    if (isImagesVisible && workspaceImagesVisible) {
      const imageRef = descBoxDomElementRef.current
      if (imageRef) {
        descBoxDomElementRef && props.domElementsRefObserver && props.domElementsRefObserver.observe(imageRef)

        return () => {
          descBoxDomElementRef && props.domElementsRefObserver && props.domElementsRefObserver.unobserve(imageRef)
        }
      }
    }
  }, [props.domElementsRefObserver, descBoxDomElementRef, isImagesVisible, workspaceImagesVisible])

  useEffect(() => {
    //essential for first render to match container width
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'))
    }, 500)
  }, [])

  return (
    <RenderByProfileOptionWrapper sectionName={UiCodePIM}>
      <div
        id={descriptionsSectionId}
        grid-data={props.datagrid}
        className={className + (!isDescriptionsFetched || !workspaceImagesVisible ? ' d-none' : '')}
        style={{ ...style }}
        ref={ref}
        onMouseDown={onMouseDown}
        onMouseUp={onMouseUp}
        onTouchEnd={onTouchEnd}
      >
        <div className='grid-layout-adjust-wrapper'>
          <div className='drag-handle-grid-container'>
            <DragOutlined />
          </div>
          <div className='diwa-container' ref={descBoxDomElementRef} id={descriptionsContainer}>
            <div className={`label-drag`}>{renderTranslation(language, TranslationKeys.buttonDescSection)}</div>
            <Descriptions />
          </div>
        </div>
      </div>
    </RenderByProfileOptionWrapper>
  )
}

export default forwardRef(DescriptionGridLayout)
